module.exports = __webpack_public_path__ + "img/other_services.166d5560.svg";